import * as React from "react";
import { useState } from "react";

import { avatarSrc } from "../../data/social";

export type AvatarSize = "sm" | "md" | "lg";

// Someone's profile photo: the one they uploaded, else their Gravatar
// (ADR 0028). Their initial shows while it loads, and stays when they have
// neither (the API answers 404). Their @name is always beside it, so it's
// hidden from screen readers, and the initial is drawn by CSS
// (`data-initial`) so it isn't copied with the name either.
const Avatar: React.FC<{
  user: { username: string; avatarPath?: string };
  size?: AvatarSize;
  className?: string;
}> = ({ user, size = "md", className }) => {
  // The path that failed to load; a new photo gets a new path, and a try.
  const [failed, setFailed] = useState<string | null>(null);
  const path = user.avatarPath;
  return (
    <span
      className={["avatar", `avatar-${size}`, className]
        .filter(Boolean)
        .join(" ")}
      data-initial={user.username.slice(0, 1).toUpperCase()}
      aria-hidden="true"
    >
      {path && path !== failed && (
        <img
          src={avatarSrc(path)}
          alt=""
          loading="lazy"
          decoding="async"
          onError={() => setFailed(path)}
        />
      )}
    </span>
  );
};

export default Avatar;
